var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"id":"category","options":_vm.categories,"label":"name","multiple":true},on:{"input":_vm.filterTable},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5237efe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/CategoryFilter.vue
// module id = 861
// module chunks = 0